'use client';

import clsx from 'clsx';
import { Card } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import React from 'react';
import { Image } from '@/components/core/components/atoms';
import { MediaType } from '@/@types';
import * as styles from './feed-background.styles';

const FeedBackground: UIComponent<{
  image?: string;
  media?: MediaType | MediaType[];
  squareMiniature?: boolean;
  withoutOverlay?: boolean;
  alt?: string;
  priority?: boolean;
  sizes?: string[];
  quality?: string | number;
  blur?: boolean;
}> = React.forwardRef(
  (
    {
      image,
      className,
      children,
      withoutOverlay,
      squareMiniature,
      blur,
      media,
      sizes = ['(max-width: 320px) 320px', '(max-width: 768px) 640px', '768px'],
      alt = 'feed background',
      quality = 80,
      ...props
    },
    ref: any,
  ) => {
    const mediaArray = (Array.isArray(media) ? media : [media]).filter(Boolean);
    const mediaValue = mediaArray.find((m) => {
      return m.type === 'image';
    });
    const isImage = !!mediaValue || !!image;
    const sourceSrc = mediaValue?.source || image;

    return (
      <Card
        ref={ref}
        className={clsx(className, styles.root, {
          [styles.withoutOverlay]: withoutOverlay,
        })}
        {...props}
      >
        {isImage && (
          <Image
            className={clsx(styles.bg, {
              [styles.blur]: squareMiniature || blur,
            })}
            sizes={sizes}
            quality={quality}
            src={sourceSrc}
            alt={alt}
          />
        )}

        {isImage && squareMiniature && (
          <section className={clsx(styles.album)}>
            <Image src={sourceSrc} alt="album" sizes={sizes} quality={quality} />
          </section>
        )}
        {children}
      </Card>
    );
  },
);

export default FeedBackground;
